import React, { createContext, useContext } from "react";
import useClientSignoffStats from "./useClientSignoffStats";

const ClientSignoffStatsContext = createContext(null);

export function ClientSignoffStatsProvider({ children }) {
  const value = useClientSignoffStats();
  return (
    <ClientSignoffStatsContext.Provider value={value}>
      {children}
    </ClientSignoffStatsContext.Provider>
  );
}

export function useClientSignoffStatsContext() {
  const ctx = useContext(ClientSignoffStatsContext);
  if (!ctx) {
    throw new Error(
      "useClientSignoffStatsContext must be used within ClientSignoffStatsProvider",
    );
  }
  return ctx;
}
